// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rt-td:hover {\n  overflow: visible;\n  white-space: normal;\n  width: auto;\n}\n\n.select-wrap select {\n  height: unset;\n  margin: unset;\n}\n\n.-pageJump input {\n  display: inline-block;\n  height: unset;\n  margin: unset;\n}\n\n.-pagination button.-btn  {\n  height: 2.25rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
